import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("ar3");

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {})
      .finally(() => setAuthChecked(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(null);
  };

  const openOrder = (plan) => {
    setSelectedPlan(plan || "ar3");
    setOrderOpen(true);
  };

  return (
    <StoreContext.Provider
      value={{
        user, authChecked, login, logout,
        orderOpen, setOrderOpen, selectedPlan, openOrder,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
